(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/casino-promo-actions/assets/javascripts/play-button.js') >= 0) return;  svs.modules.push('/components/banner_actions/casino-promo-actions/assets/javascripts/play-button.js');

'use strict';

class PlayButton {
  constructor(gameModel, el) {
    this.gameModel = gameModel;
    this.el = el;
    this.gameName = this.gameModel.name;
    this.playButton = this.el.querySelector('.js-casinopromo-play-button');
    this.addElementListeners();
  }
  addElementListeners() {
    this.playButton.addEventListener('click', e => {
      e.preventDefault();
      svs.components.casino.shared.startGame('spela', this.gameName, this.getPromoData(), this.gameModel);
    });
  }
  getWidgetPosition(el) {
    const widgetStdClass = 'widget';
    const allWidgetsInDom = Array.from(document.getElementsByClassName(widgetStdClass));
    const thisWidgetElement = el.closest('div.widget');
    return allWidgetsInDom.indexOf(thisWidgetElement) + 1;
  }
  getPromoData() {
    const promoData = {
      name: window.location.pathname,
      title: this.el.dataset.impressionTracking,
      position: this.getWidgetPosition(this.el)
    };
    return promoData;
  }
}
setGlobal('svs.banner_actions.casino_promo_actions', {
  PlayButton
});

 })(window);